import React from 'react';
import Cta from '../components/Cta';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import Hero1 from '../components/Hero1';
import Portfolio1 from '../components/Portfolio1';
import Services1 from '../components/Services1';

function Home1() {
    return (
        <>
            <Header1 />
            <div className='container  section-padding'>
                <div className='row'>
                    <div className='col-md-8 col-12'>
                        <Hero1 />
                    </div>
                    <div className='col-md-4 col-12'>
                        <p className='mb-3 text-justify'>
                            <b>Cytocare Technologies </b>is a service provider for clinical researcher, Medical Oncologist, Haematologist and regulatory experts involved in cell processing and stem cell therapy. We endeavour to promote our diversity, so fostering the original thoughts and creativity. By partnering with the most artistic biotechnology in the globe we will continue to meet the requirement of our customer while searching for new opportunities to address unmet scientific and clinical needs.
                        </p>
                        <p className='mb-3 text-justify'>
                            Our Research and Clinical application programs address Technologies such as stem cell collection, Cell processing (includes Cryopreservation and Cryo shipping), Cell separation and Transplantation. Partnering in cGMP laboratory ensure the production of desired cells for Cell based therapies of malignant and non-malignant blood diseases and its Regenerative medicine applications.
                        </p>
                    </div>
                </div>
            </div>
            <Services1 />
            <div className='container section-padding'>
                <div className="row g-3">
                    <div className="col-12">
                        <div className="section-title text-center">
                            <h3>Empowering Discovery. Advancing Cell Therapy</h3>
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#aec738", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            Cell & Gene Therapy
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#fdcb0a", color: "#333", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">Graft Engineering</div>
                            
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#982c75", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            Cell Processing & Cryopreservation
                            </div>
                            
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#6b6d6c", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            T Cell Depletion in Grafting Engineering
                            </div>
                            
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#cda367", color: "#333", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            Virus Specific T Cells For immunotherapy
                            </div>
                            
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#a45c50", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            Dentric Cells For Immunotherapy
                            </div>
                           
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#2b80c3", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            NK Cells For Immunotherapy
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#5d8c44", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            Stem Cell Enrichment in Engineering
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#6f7889", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                            Gene Engineered Hemotopoietic Stem Cell (HSCs)
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6 col-12'>
                        <div className='text-center p-3 d-flex' style={{backgroundColor: "#f38222", color: "#fff", borderRadius: "8px", height: "90px"}}>
                            <div className="justify-content-center align-self-center w-100">
                                Adherent Cell Culture System
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Portfolio1 />
            {/* <div className='container section-padding'>
                <div className="row">
                    <div className="col-12">
                        <div className="section-title text-center">
                            <h3>Clinimac Protocol</h3>
                        </div>
                    </div>
                </div>
                <div className="row g-3 justify-content-md-center">
                    <div className="col-md-4 col-12" style={{maxHeight: "480px"}}>
                        <img src={HeroBg2} className="w-100" style={{height: "350px"}} />
                    </div>
                    <div className="col-md-4 col-12" style={{maxHeight: "480px"}}>
                        <img src={HeroBg8} className="w-100" style={{height: "350px"}} />
                    </div>
                    <div className="col-md-4 col-12" style={{maxHeight: "480px"}}>
                        <img src={HeroBg10} className="w-100" style={{height: "350px"}} />
                    </div>
                    <div className="col-md-4 col-12" style={{maxHeight: "480px"}}>
                        <img src={HeroBg11} className="w-100" style={{height: "350px"}} />
                    </div>
                    <div className="col-md-4 col-12" style={{maxHeight: "480px"}}>
                        <img src={HeroBg13} className="w-100" style={{height: "350px"}} />
                    </div>
                    <div className="col-md-4 col-12" style={{maxHeight: "480px"}}>
                        <img src={HeroBg14} className="w-100" style={{height: "350px"}} />
                    </div>
                </div>
            </div> */}
            <Footer1 />
        </>
    );
}

export default Home1;
